// extracted by mini-css-extract-plugin
export var dropdown = "_s0-0";
export var imageWrapper = "_s0-3";
export var itemNameContainer = "_s0-1";
export var productImage = "_s0-2";
export var spinnerWrapper = "_s0-4";